export const manifest = {
  screens: {
    scr_t56cm7: { name: "Upload", route: "/", state: {"empty":true} },
    scr_t6sfeb: { name: "Editor", route: "/" },
  },
}
